var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Col from "../../ui/Col/Col";
import "./BlockWrapper.scss";
var getDimension = function (dimension) {
    var allowedDimensions = ["1", "1-2", "1-3", "2-3"];
    if (allowedDimensions.includes(dimension))
        return dimension;
    else
        return "1";
};
var getAlignment = function (alignment) {
    var allowedAlignments = ["l", "r"];
    if (allowedAlignments.includes(alignment))
        return alignment;
    else
        return "";
};
export var BlockWrapper = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var noGutter = _a.noGutter, children = _a.children, className = _a.className, style = _a.style, _p = _a.verticalSpacing, verticalSpacing = _p === void 0 ? "medium" : _p, props = __rest(_a, ["noGutter", "children", "className", "style", "verticalSpacing"]);
    var getColumnWidth = function (dimension) {
        if (dimension === "1-2")
            return 12;
        else if (dimension === "1-3")
            return 8;
        else if (dimension === "2-3")
            return 16;
        else
            return 24;
    };
    return (_jsx(Col, __assign({ id: props.id, xs: { span: getColumnWidth((_b = props === null || props === void 0 ? void 0 : props.xs) === null || _b === void 0 ? void 0 : _b.dimension), order: (_c = props === null || props === void 0 ? void 0 : props.xs) === null || _c === void 0 ? void 0 : _c.order }, md: { span: getColumnWidth((_d = props === null || props === void 0 ? void 0 : props.md) === null || _d === void 0 ? void 0 : _d.dimension), order: (_e = props === null || props === void 0 ? void 0 : props.md) === null || _e === void 0 ? void 0 : _e.order }, xl: { span: getColumnWidth((_f = props === null || props === void 0 ? void 0 : props.xl) === null || _f === void 0 ? void 0 : _f.dimension), order: (_g = props === null || props === void 0 ? void 0 : props.xl) === null || _g === void 0 ? void 0 : _g.order }, className: className, "data-testid": (props === null || props === void 0 ? void 0 : props["data-testid"]) || undefined, style: style }, { children: _jsx("div", __assign({ className: "block-wrapper-container block-wrapper-container--vertical-spacing-".concat(verticalSpacing) }, { children: noGutter ? (_jsx("div", { children: children })) : (_jsx("div", __assign({ className: "block-wrapper block-wrapper--xs-".concat(getDimension((_h = props === null || props === void 0 ? void 0 : props.xs) === null || _h === void 0 ? void 0 : _h.dimension)).concat(getAlignment((_j = props === null || props === void 0 ? void 0 : props.xs) === null || _j === void 0 ? void 0 : _j.alignment), " \n                        block-wrapper--md-").concat(getDimension((_k = props === null || props === void 0 ? void 0 : props.md) === null || _k === void 0 ? void 0 : _k.dimension)).concat(getAlignment((_l = props === null || props === void 0 ? void 0 : props.md) === null || _l === void 0 ? void 0 : _l.alignment), "\n                        block-wrapper--xl-").concat(getDimension((_m = props === null || props === void 0 ? void 0 : props.xl) === null || _m === void 0 ? void 0 : _m.dimension)).concat(getAlignment((_o = props === null || props === void 0 ? void 0 : props.xl) === null || _o === void 0 ? void 0 : _o.alignment)) }, { children: children }))) })) })));
};
